import React, { useState, useEffect } from 'react';
import { InlineFileValue } from '../../../common/inline/InlineFile';
import { useUpdateProductDesignOutput } from '../Product.hooks';
import {
  ProductDesignOutput,
  BaseProductDesignOutputCardProps
} from '../Product.interface';
import { useUpdateTask } from '../../tasks/Task.hooks';
import { FetchError } from '../../../common/api/api';
import AssessmentCard, {
  getAssessmentInitialValues
} from '../../../common/cards/AssessmentCard';

const DesignOutputRiskAssessmentCard: React.FC<BaseProductDesignOutputCardProps> =
  (props: BaseProductDesignOutputCardProps) => {
    const [initialValues, setInitialValues] =
      useState<Partial<ProductDesignOutput>>();
    const { productId, productDesignOutput, onChange, onUpdate, onError } =
      props;
    const {
      updatedProductDesignOutput,
      isUpdatingProductDesignOutput: isUpdating,
      updateProductDesignOutputError: updateError,
      updateProductDesignOutput
    } = useUpdateProductDesignOutput(productId, productDesignOutput.id);
    const {
      updatedTask,
      updateError: updateTaskError,
      updateTask
    } = useUpdateTask(productDesignOutput.task.id || 0);
    useEffect(() => {
      setInitialValues(getAssessmentInitialValues(productDesignOutput));
    }, [productDesignOutput]);
    const error: FetchError | undefined = updateError || updateTaskError;

    useEffect(() => {
      if (updatedProductDesignOutput) {
        onChange?.(updatedProductDesignOutput);
        onUpdate?.();
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [updatedProductDesignOutput]);

    useEffect(() => {
      if (updatedTask) {
        productDesignOutput.task = Object.assign(
          productDesignOutput.task || {},
          updatedTask
        );
        onChange?.(productDesignOutput);
        onUpdate?.();
      }
    }, [updatedTask]);

    useEffect(() => {
      if (error) {
        onError?.(error);
      }
    }, [error]);

    const handleAttachmentChange = (attachments: InlineFileValue[]) => {
      updateTask({ attachments });
      if (productDesignOutput.task) {
        productDesignOutput.task.attachments = attachments;
      }
      onChange?.(productDesignOutput);
    };

    return (
      <AssessmentCard
        initialValues={initialValues}
        isLoading={isUpdating}
        task={productDesignOutput.task}
        error={error}
        onSubmit={values => {
          updateProductDesignOutput(values);
          onChange?.(values);
        }}
        onChangeAttachments={handleAttachmentChange}
      />
    );
  };

export default DesignOutputRiskAssessmentCard;
